import { useMutation, useQuery, useQueryClient } from 'react-query';
import axiosInstance from '../config/Axios';
import { useCustomToast } from '../pages/Contexts/ToastContext';

/**
 * Quick Show — the "Add to Screen" one-click flow.
 *
 * Backend: POST /api/quick-show           — start
 *          POST /api/quick-show/{id}/stop — revert all assigned devices
 *          GET  /api/quick-show/active    — list currently-active rows
 */

export const useStartQuickShow = () => {
  const qc = useQueryClient();
  const { showToast } = useCustomToast();
  return useMutation(
    (payload) => axiosInstance.post('/quick-show', payload),
    {
      onSuccess: () => {
        qc.invalidateQueries('activeQuickShows');
        // Devices list reflects the new "now playing" — bust both shapes.
        qc.invalidateQueries('getGroupedDevices');
        qc.invalidateQueries('getDevicesList');
      },
      onError: (err) => showToast('error', 'Quick Show', err.response?.data?.message ?? 'Failed.'),
    },
  );
};

export const useStopQuickShow = () => {
  const qc = useQueryClient();
  const { showToast } = useCustomToast();
  return useMutation(
    (campaignId) => axiosInstance.post(`/quick-show/${campaignId}/stop`),
    {
      onSuccess: () => {
        qc.invalidateQueries('activeQuickShows');
        qc.invalidateQueries('getGroupedDevices');
        qc.invalidateQueries('getDevicesList');
      },
      onError: (err) => showToast('error', 'Quick Show', err.response?.data?.message ?? 'Failed.'),
    },
  );
};

export const useActiveQuickShows = (enabled = true) => {
  return useQuery(
    'activeQuickShows',
    async () => (await axiosInstance.get('/quick-show/active')).data,
    {
      enabled,
      refetchInterval: 30_000,   // light poll so badge stays fresh
      staleTime: 10_000,
    },
  );
};
